export const PATHS = {
  changePassword: "/change-password",
  conversations: "/conversations",
  dashboard: "/dashboard",
  onboardingInterests: "/onboarding-interests",
  onboardingLocations: "/onboarding-locations",
  onboardingPlans: "/onboarding-plans",
  onboardingUser: "/onboarding-user",
  onboardingCheckoutConfirm: "/onboarding-checkout",
  plans: "/plans",
  products: "/products",
  productView: "/products/view",
  productCreate: "/products/create",
  productUpdate: "/products/update",
  resetPassword: "/reset-password",
  root: "",
  settings: "/settings",
  signUp: "/sign-up",
  signIn: "/sign-in",
  checkoutConfirm: "/checkout",
  subscriptions: "/subscriptions",
  swipes: "/swipes",
  tags: "/tags",
  team: "/team",
  teamCreate: "/team/create",
  teamUpdate: "/team/update",
  user: "/user/view",
  userProducts: "/users/products",
  userUpdate: "/user/update",
};
